var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chart',_vm._b({ref:"chart",attrs:{"id":'mrrStat',"scope":"mrr","params":Object.assign({}, {type: 'mrr',
    date_from: this.$moment(_vm.dateFrom).format("YYYY-MM-DD")},
    (_vm.$_.isNil(_vm.importId) ? {} : { mrr_import_id: _vm.importId })),"value-path":"result","value-func":_vm.getChartData,"config":_vm.config}},'chart',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }